import Submenu from "./submenu";

export default class MenuItem {
  #name = ""
  #icon = ""
  #url = ""
  #path = ""
  #external = false
  #prepaid = false
  #applyCoupon = false
  #submenus = []

  static fromJSONResponse(json) {
    return new MenuItem()
      .setName(json.name)
      .setIcon(json.icon)
      .setUrl(json.url)
      .setPath(json.path)
      .setExternal(json.external)
      .setPrepaid(json.prepaid)
      .setApplyCoupon(json.coupon)
      .setSubmenus(json.submenus.map((submenu) => Submenu.fromJSONResponse(submenu)))
  }

  getName() {
    return this.#name
  }

  getIcon() {
    return this.#icon
  }

  getUrl() {
    return this.#url
  }

  getPath() {
    return this.#path
  }

  getExternal() {
    return this.#external
  }

  getPrepaid() {
    return this.#prepaid
  }

  getSubmenus() {
    return this.#submenus
  }

  getApplyCoupon() {
    return this.#applyCoupon
  }

  setName(value) {
    this.#name = value
    return this
  }

  setIcon(value) {
    this.#icon = value
    return this
  }

  setUrl(value) {
    this.#url = value;
    return this
  }

  setPath(value) {
    this.#path = value
    return this
  }

  setExternal(value) {
    this.#external = value
    return this
  }

  setPrepaid(value) {
    this.#prepaid = value
    return this
  }

  setSubmenus(value) {
    this.#submenus = value
    return this
  }

  setApplyCoupon(value) {
    this.#applyCoupon = value
    return this
  }
}
